/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/journal/2020-02-12.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/journal/2020-02-12.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/2020-02-12.mdx';

const metadata = {
  slug: "2020-02-12",
  title: "The 1/3 Life Crisis",
  author: "Christian Battaglia",
  description: "At 26 I've completed roughly 33% of my life — and according to the optimal stopping problem, I've got 4% more before I should settle down. Plus: NYC housing math, work-life balance rules, and who you should look up to.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2020-02-12T00:00:00.000Z",
  
  readTime: "5 min read",
  tags: ["life philosophy","optimal stopping","NYC","housing","work-life balance","math","Moulin Rouge","personal growth"],
};

export const Route = createFileRoute('/blog/posts/2020-02-12')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/2020-02-12',
    image: '/og/blog/2020-02-12.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
